(function() {
  // Récupération immédiate des paramètres
  const params = new URLSearchParams(window.location.search);
  const variantId = params.get('variant');
  
  if (!variantId) return;
  
  // Fonction pour sélectionner la couleur
  function selectColor(colorValue) {
    const blackItem = document.querySelector(`.custom-dropdown-item[data-value="${colorValue}"]`);
    
    if (blackItem) {
      // Retirer selected de tous
      document.querySelectorAll('.custom-dropdown-item').forEach(item => {
        item.classList.remove('selected');
      });
      
      // Ajouter selected à la couleur cible
      blackItem.classList.add('selected');
      
      // Cliquer
      blackItem.click();
      
      // Déclencher un événement de changement si nécessaire
      const event = new Event('change', { bubbles: true });
      blackItem.dispatchEvent(event);
      
      // Vérifier si un select caché doit être mis à jour
      const hiddenSelect = document.querySelector('select[data-index="option3"]');
      if (hiddenSelect) {
        hiddenSelect.value = colorValue;
        hiddenSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
      
      // Masquer les messages d'erreur
      const selectColorMsg = document.querySelector('#color-error-message');
      if (selectColorMsg) selectColorMsg.style.display = 'none';
      
      const errorText = Array.from(document.querySelectorAll('*')).find(el => 
        el.textContent === 'Select frame color.'
      );
      if (errorText) errorText.style.display = 'none';
      
      return true;
    }
    
    return false;
  }
  
  // Fonction principale avec retry intelligent
  function applyVariant(retryCount = 0) {
    const maxRetries = 20;
    
    // Vérifier si les éléments sont prêts
    const variantDataEl = document.querySelector('[data-variant-json]');
    const colorItems = document.querySelectorAll('.custom-dropdown-item');
    
    // Si les éléments ne sont pas prêts, réessayer
    if (!variantDataEl || colorItems.length === 0) {
      if (retryCount < maxRetries) {
        setTimeout(() => applyVariant(retryCount + 1), 100);
      }
      return;
    }
    
    try {
      const variants = JSON.parse(variantDataEl.textContent || variantDataEl.value);
      const targetVariant = variants.find(v => v.id == variantId);
      
      if (!targetVariant) return;
      
      // 1. Sélectionner Frame Option
      const frameSelect = document.querySelector('select[data-index="option1"]');
      if (frameSelect && targetVariant.option1) {
        frameSelect.value = targetVariant.option1;
        frameSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
      
      // 2. Sélectionner Size
      const sizeSelect = document.querySelector('select[data-index="option2"]');
      if (sizeSelect && targetVariant.option2) {
        sizeSelect.value = targetVariant.option2;
        sizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
      
      // 3. Sélectionner Color avec délai pour s'assurer que le DOM est prêt
      if (targetVariant.option3) {
        // Essayer immédiatement
        if (!selectColor(targetVariant.option3)) {
          // Si échoué, réessayer avec délais progressifs
          let colorRetry = 0;
          const tryColor = () => {
            if (!selectColor(targetVariant.option3) && colorRetry < 10) {
              colorRetry++;
              setTimeout(tryColor, 200);
            }
          };
          setTimeout(tryColor, 300);
        }
      }
      
      // 4. Forcer la mise à jour du variant principal
      setTimeout(() => {
        const mainSelect = document.querySelector('select[name="id"]');
        if (mainSelect) {
          mainSelect.value = variantId;
          mainSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }, 800);
      
    } catch (e) {
      console.error('Erreur:', e);
    }
  }
  
  // Fonction d'initialisation avec plusieurs stratégies
  function init() {
    // Stratégie 1: Si le DOM est déjà complet
    if (document.readyState === 'complete') {
      setTimeout(() => applyVariant(0), 500);
    }
    
    // Stratégie 2: Attendre DOMContentLoaded
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(() => applyVariant(0), 500);
    });
    
    // Stratégie 3: Attendre load complet
    window.addEventListener('load', () => {
      setTimeout(() => applyVariant(0), 500);
    });
    
    // Stratégie 4: Observer les mutations pour détecter quand les éléments sont ajoutés
    const observer = new MutationObserver((mutations, obs) => {
      // Si on trouve les custom-dropdown-items, on lance
      if (document.querySelectorAll('.custom-dropdown-item').length > 0) {
        obs.disconnect();
        setTimeout(() => applyVariant(0), 200);
      }
    });
    
    // Observer le body pour les changements
    if (document.body) {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
      
      // Arrêter l'observer après 5 secondes
      setTimeout(() => observer.disconnect(), 5000);
    }
  }
  
  // CSS pour stabiliser l'affichage
  const style = document.createElement('style');
  style.textContent = `
    /* S'assurer que la sélection est visible immédiatement */
    .custom-dropdown-item.selected {
      opacity: 1 !important;
      font-weight: bold;
    }
    
    /* Masquer les messages d'erreur pendant le chargement initial */
    .loading-variant #color-error-message {
      display: none !important;
    }
  `;
  document.head.appendChild(style);
  
  // Ajouter classe de chargement
  document.body.classList.add('loading-variant');
  
  // Retirer après 2 secondes
  setTimeout(() => {
    document.body.classList.remove('loading-variant');
  }, 2000);
  
  // Lancer l'initialisation
  init();
  
})();